<template lang="pug">
.file-container(v-if="!isNew")
    .files
        a.aiq-link-preview(@click.prevent="onHandleView()"
                            :href="link")
            font-awesome-icon(:icon="getIconType[0]" :class="getIconType[1]")
            span.text-info {{ getFileName }}
        .trash(v-if="canRemoveFile")
          font-awesome-icon(v-if="progress.uploadPercent === 100" @click="onHandleDelete()" icon="fa-trash-can-xmark" class="trash-icon")

    .progress-bar-container()
        aiq-progress.progress-bar(:percentage="progress.uploadPercent"
            :stroke-width="5"
            :format="() => ''"
            :status="progress.uploadStatus")
        .progress-status
          span {{progress.progressBarStatus}} | {{progress.uploadPercent}}%
</template>
<script>
import get from 'lodash/get';
import GetGlobalSource from '@/libs/mixins/GetGlobalSource';
import {iconClasses, RECORD_KINDS} from './smartDriveUtil';

export default {
  name: 'view-files',
  mixins: [GetGlobalSource],
  emits: ['onDeleteFile'],
  props: {
    record: {
      type: Object,
      default: () => { },
    },
    progress: {
      type: Object,
      default: () => { },
    },
    canRemoveFile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isNew() {
      return get(this.record, 'file.payload.name', '') === '';
    },
    getFileName() {
      return get(this.record, 'file.payload.name', '');
    },
    link() {
      return get(this.record, 'file.payload.url', '');
    },
    getIconType() {
      const object_type = get(this.record, 'file.payload.mime', '');
      return iconClasses(object_type);
    },
  },
  methods: {

    async onHandleView() {
      const url = await this.getFileUrl(get(this.record, 'file.payload'));
      if (url) {
        window.open(url, '_blank');
      }
    },
    onHandleDelete() {
      this.$emit('onDeleteFile', {
        file: this.record.file,
        type: RECORD_KINDS.FILE,
      });
    },

  },
};
</script>
<style lang="scss" scoped>
@import "./icon.scss";

.aiq-link-preview{
    display: flex;
    gap: 10px;
    cursor: pointer;
}

.trash-icon {
   margin-right: 10px;
   color: rgb(218, 55, 55);
   cursor: pointer;
}

.progress-bar {
    padding-top: 10px;
    width: 325px;
}
.files {
    display: flex;
    justify-content: space-between;
}
.text-info {
    font-size: 16px;
}
.file-container {
    width: 400px;
    height: 200px;
    border: #dcdfe6 1px solid;
    box-shadow: 0 0 0 1px #dcdfe6 inset;
    padding-top:10px;
    padding-left: 10px;
}

</style>